export default Object.freeze([
  { label: "พนักงานขับรถ", value: "Driver" },
  { label: "ผู้ช่วยพนักงานขับรถ", value: "Helper" },
]);
